module.exports = __webpack_public_path__ + "images/marketing/peeps/likes/zen_newman.jpg";